import { render, staticRenderFns } from "./TaskComments.vue?vue&type=template&id=0cd10fbd&scoped=true"
import script from "./TaskComments.vue?vue&type=script&lang=js"
export * from "./TaskComments.vue?vue&type=script&lang=js"
import style0 from "./TaskComments.vue?vue&type=style&index=0&id=0cd10fbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd10fbd",
  null
  
)

export default component.exports